/**
 * Elsklip Coupon Accessibility
 *
 * Converts the custom coupon widget into a keyboard-operable checkbox.
 * Enter and Space toggle the underlying checkbox, while aria-checked
 * stays synchronized with its current state.
 */

(function () {
  let updateScheduled = false;

  function fixCouponA11y() {
    document
      .querySelectorAll(".elsklip-coupon__widget")
      .forEach(function (widget) {
        const input = widget.querySelector('input[type="checkbox"]');

        const labelText =
          widget.querySelector("[data-label-text]")?.textContent?.trim() ||
          widget.textContent.trim() ||
          "Apply coupon";

        if (!input || widget.dataset.a11yFixed === "true") return;

        widget.setAttribute("role", "checkbox");
        widget.setAttribute("tabindex", "0");
        widget.setAttribute("aria-label", labelText);
        widget.setAttribute("aria-checked", input.checked ? "true" : "false");

        function syncState() {
          widget.setAttribute("aria-checked", input.checked ? "true" : "false");
        }

        widget.addEventListener("keydown", function (event) {
          if (event.key !== "Enter" && event.key !== " ") return;

          event.preventDefault();
          event.stopPropagation();

          input.click();

          window.setTimeout(syncState, 100);
        });

        widget.addEventListener("click", function () {
          window.setTimeout(syncState, 100);
        });

        input.addEventListener("change", syncState);

        widget.dataset.a11yFixed = "true";
      });
  }

  function scheduleCouponFix() {
    if (updateScheduled) return;

    updateScheduled = true;

    requestAnimationFrame(function () {
      updateScheduled = false;
      fixCouponA11y();
    });
  }

  function initCouponAccessibility() {
    fixCouponA11y();

    window.setTimeout(fixCouponA11y, 1000);
    window.setTimeout(fixCouponA11y, 2500);

    new MutationObserver(scheduleCouponFix).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  window.ASA11y.onReady(initCouponAccessibility);
})();
